module.exports = __webpack_public_path__ + "static/media/bg_curve_02.ab99e4e0.svg";